class ProjectConst {
    static Inventory = 'module-project-inventory';
    static Refresh = 'refresh';
    static Property = 'property';
    static Tower = 'tower';
    static Contact = 'contact';
    static Document = 'document';
}
export default ProjectConst;